import React from 'react';

// Three-column 45-row Devata names table. Renders only for layerId 'compass-45-2'.
// Inline names array intentionally kept here (matches the original; minor spelling differences
// vs constants/devata.js — preserving source-of-truth for this view).
const DevataBlocksTable = ({ layerId }) => {
  if (layerId !== 'compass-45-2') return null;

  const Devata_NAMES = [
    { srNo: 1,  name: 'BRAHMA' },
    { srNo: 2,  name: 'BHUDHAR' },
    { srNo: 3,  name: 'ARYAMA' },
    { srNo: 4,  name: 'VIVISWAN' },
    { srNo: 5,  name: 'MITRA' },
    { srNo: 6,  name: 'AAPAHA' },
    { srNo: 7,  name: 'AAPAHA-VATSA' },
    { srNo: 8,  name: 'SAVITA' },
    { srNo: 9,  name: 'SAVITRA' },
    { srNo: 10, name: 'INDRA' },
    { srNo: 11, name: 'JAYA' },
    { srNo: 12, name: 'RUDRA' },
    { srNo: 13, name: 'RAJYA-KSHMA' },
    { srNo: 14, name: 'SHIKHI' },
    { srNo: 15, name: 'PARJANYA' },
    { srNo: 16, name: 'JAYANTI' },
    { srNo: 17, name: 'MAHENDRI' },
    { srNo: 18, name: 'SURYA' },
    { srNo: 19, name: 'SATYA' },
    { srNo: 20, name: 'BHRISHA' },
    { srNo: 21, name: 'ANTRIKSH' },
    { srNo: 22, name: 'ANIL' },
    { srNo: 23, name: 'PUSHA' },
    { srNo: 24, name: 'VITASTA' },
    { srNo: 25, name: 'GRISHSPATYA' },
    { srNo: 26, name: 'YAMA' },
    { srNo: 27, name: 'GANDHARVA' },
    { srNo: 28, name: 'BHRINGRAJ' },
    { srNo: 29, name: 'MRIGAH' },
    { srNo: 30, name: 'PITRA' },
    { srNo: 31, name: 'DAUWARIK' },
    { srNo: 32, name: 'SUGREEV' },
    { srNo: 33, name: 'PUUSHPDANT' },
    { srNo: 34, name: 'VARUN' },
    { srNo: 35, name: 'ASUR' },
    { srNo: 36, name: 'SHOSHA' },
    { srNo: 37, name: 'PAPYA-KSHMA' },
    { srNo: 38, name: 'ROGA' },
    { srNo: 39, name: 'AHIR' },
    { srNo: 40, name: 'MUKHYA' },
    { srNo: 41, name: 'BHALLAT' },
    { srNo: 42, name: 'SOMA' },
    { srNo: 43, name: 'BHUJAG' },
    { srNo: 44, name: 'ADITI' },
    { srNo: 45, name: 'DITI' },
  ];

  const col1 = Devata_NAMES.slice(0, 15);
  const col2 = Devata_NAMES.slice(15, 30);
  const col3 = Devata_NAMES.slice(30, 45);

  return (
    <div style={{
      marginTop: '20px', padding: '16px',
      backgroundColor: '#f5f5f5', borderRadius: '8px',
      border: '1px solid #ddd', width: '800px',
    }}>
      <div style={{
        display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)',
        gap: '20px', marginBottom: '12px',
      }}>
        {['SR | Devata NAME', 'SR | Devata NAME', 'SR | Devata NAME'].map((title, i) => (
          <div key={i} style={{
            backgroundColor: '#00A19D', color: '#000',
            padding: '8px 12px', fontWeight: 'bold', fontSize: '12px',
            borderRadius: '4px', textAlign: 'center',
          }}>{title}</div>
        ))}
      </div>

      <div style={{
        display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '20px',
      }}>
        {[col1, col2, col3].map((col, colIdx) => (
          <div key={colIdx} style={{ display: 'flex', flexDirection: 'column', gap: '1px' }}>
            {col.map((item, idx) => (
              <div
                key={`col${colIdx + 1}-${item.srNo}`}
                style={{
                  display: 'grid', gridTemplateColumns: '40px 1fr', gap: '8px',
                  padding: '6px 8px',
                  backgroundColor: idx % 2 === 0 ? '#fff' : '#f9f9f9',
                  borderBottom: '1px solid #eee', fontSize: '11px',
                  alignItems: 'center',
                }}
              >
                <span style={{ fontWeight: 'bold', color: '#00A19D', textAlign: 'center' }}>
                  {item.srNo}
                </span>
                <span style={{ color: '#333' }}>{item.name}</span>
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

export default DevataBlocksTable;
